import { render, staticRenderFns } from "./assessMsgHandle.vue?vue&type=template&id=410f6108&scoped=true"
import script from "./assessMsgHandle.vue?vue&type=script&lang=js"
export * from "./assessMsgHandle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f6108",
  null
  
)

export default component.exports